import { render, staticRenderFns } from "./LogoutSuccessful.vue?vue&type=template&id=1007668d&scoped=true"
import script from "./LogoutSuccessful.vue?vue&type=script&lang=js"
export * from "./LogoutSuccessful.vue?vue&type=script&lang=js"
import style0 from "./LogoutSuccessful.vue?vue&type=style&index=0&id=1007668d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007668d",
  null
  
)

export default component.exports